import { inject, type InjectionKey } from 'vue'
import type { PanelInstance } from '~/stores/usePanelStore'

export interface PanelContext {
  instance: PanelInstance
  portal: string
  extension: string
  panelMode: 'panel' | 'modal'
  close: (force?: boolean) => Promise<boolean>
  replace: (key: string, props?: Record<string, unknown>) => void
  mode: () => void
  registerShouldDismiss: (fn: (() => boolean) | null) => void
  registerWillDismiss: (fn: (() => void) | null) => void
  registerDidDismiss: (fn: (() => void) | null) => void
  registerDidAttemptToDismiss: (fn: (() => void) | null) => void
}

export const PanelContextKey: InjectionKey<PanelContext> = Symbol('PanelContext')

export function usePanel(): PanelContext {
  const ctx = inject(PanelContextKey)
  if (!ctx) {
    throw new Error('usePanel() must be called inside a panel component (under PanelHost).')
  }
  return ctx
}
